import type {Readable} from 'svelte/store';
import {writable} from 'svelte/store';
import {getContext, setContext} from 'svelte';

const SEARCH_TOOLBAR_CONTEXT_KEY = 'search-toolbar-context';

export interface SearchToolbarContext {
    lastSearchQuery$: Readable<string | null>;
    updateLastSearchQuery: (query: string | null) => void;
}

export function createSearchToolbarContext() {
    const lastSearchQuery = writable<string | null>(null);

    setContext<SearchToolbarContext>(SEARCH_TOOLBAR_CONTEXT_KEY, {
        lastSearchQuery$: lastSearchQuery,
        updateLastSearchQuery: (query) => lastSearchQuery.set(query)
    });
}

export function getSearchToolbarContext(): SearchToolbarContext {
    return getContext<SearchToolbarContext>(SEARCH_TOOLBAR_CONTEXT_KEY);
}